import { render, staticRenderFns } from "./Banlance.vue?vue&type=template&id=05b12643&scoped=true&"
import script from "./Banlance.vue?vue&type=script&lang=js&"
export * from "./Banlance.vue?vue&type=script&lang=js&"
import style0 from "./Banlance.vue?vue&type=style&index=0&id=05b12643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b12643",
  null
  
)

export default component.exports